{
  "$schema": "https://mux.run/theme.json",
  "name": "Monokai",
  "id": "monokai",
  "light": {
    "palette": {
      "neutral": "#fdf8ec",
      "ink": "#292318",
      "primary": "#bf7bff",
      "accent": "#d9487c",
      "success": "#4fb54b",
      "warning": "#f1a948",
      "error": "#e54b4b",
      "info": "#2d9ad7",
      "diffAdd": "#bfe7a3",
      "diffDelete": "#f6a3ae"
    },
    "overrides": {
      "syntax-comment": "#8a816f",
      "syntax-keyword": "#d9487c",
      "syntax-string": "#8a6500",
      "syntax-primitive": "#3c8d2f",
      "syntax-property": "#1f88c8",
      "syntax-constant": "#9b5fe0"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#272822",
      "ink": "#f8f8f2",
      "primary": "#ae81ff",
      "accent": "#f92672",
      "success": "#a6e22e",
      "warning": "#fd971f",
      "error": "#f92672",
      "info": "#66d9ef",
      "diffAdd": "#4d7f2a",
      "diffDelete": "#f4477c"
    },
    "overrides": {
      "syntax-comment": "#75715e",
      "syntax-keyword": "#f92672",
      "syntax-string": "#e6db74",
      "syntax-primitive": "#a6e22e",
      "syntax-property": "#66d9ef",
      "syntax-constant": "#ae81ff"
    }
  }
}
